// Material UI
import { makeStyles } from '@material-ui/core'
// Consts
import Colors from '../../../../constants/Colors'

export default makeStyles(theme => ({
  customAlertRoot: {},
  description: {
    color: Colors.PRIMARY_FONT_COLOR,
    fontSize: 12,
    lineHeight: 'normal',
  },
  root: {
    display: 'grid',
    gridRowGap: 10,
    justifyItems: 'center',
  },
}))
